import React from 'react';
import { FOOTER_ORG_LABEL, SPURR_TECH_URL } from '@core/config/branding';

const AppFooter: React.FC = () => {
  const year = new Date().getFullYear();
  const version = process.env.REACT_APP_VERSION?.trim();

  return (
    <footer className="ntcog-footer" role="contentinfo">
      <div className="ntcog-footer__inner">
        <span className="ntcog-footer__copyright">
          &copy; {year} {FOOTER_ORG_LABEL}
        </span>
        <span className="ntcog-footer__separator" aria-hidden> · </span>
        <span className="ntcog-footer__powered">
          Powered by{' '}
          <a
            href={SPURR_TECH_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ntcog-footer__link"
          >
            Spurr Technologies
          </a>
        </span>
        {version ? (
          <>
            <span className="ntcog-footer__separator" aria-hidden> · </span>
            <span className="ntcog-footer__version" title={`Application version ${version}`}>
              v{version}
            </span>
          </>
        ) : null}
      </div>
    </footer>
  );
};

export default AppFooter;
